<template>
  <v-select :class="{'small':sm}" ref="account-select" v-bind:multiple="multiple || selectProps.multiple"
            v-model="selected" :disabled="disabled"
            :filterable="false" :options="options" @search="onSearch"
            :placeholder="placeholder"
  >
    <template #option="{label}">
      <b-avatar button  class="pull-up" size="sm" variant="primary" :text="accounts[label].acronym" v-b-tooltip :title="accounts[label].name"></b-avatar>
      {{ accounts[label].id }} - {{ accounts[label].name }} ({{ accounts[label].buName}}) - {{ accounts[label].balance }} {{ accounts[label].currency }}
    </template>
    <template #selected-option="{label}">
      <div>
        <div v-if="accounts[label]">
          <b-avatar v-if="disabled == null || disabled === false" button  class="pull-up" size="sm" variant="primary" :text="accounts[label].acronym" v-b-tooltip :title="accounts[label].name"></b-avatar>
          {{ accounts[label].id }} -  {{ accounts[label].name }}
        </div>
        <div v-else>
          <b-skeleton size="sm" type="avatar"/>
        </div>
      </div>
    </template>
    <template #list-header>
      <div class="text-right" v-if="optionsPages > 1 && loading !== true">
        <b-button variant="outline-primary" size="sm" @click="updatePage(-1)" v-if=" optionsPage > 1" :disabled="loading">Prev</b-button>
        <span>({{optionsPage}}/{{optionsPages}})</span>
        <b-button variant="outline-primary" size="sm"  @click="updatePage(1)" v-if="optionsPage < optionsPages"  v-bind:disabled="loading">Next</b-button>
      </div>
      <div class="text-right" v-if="optionsPages > 1 && loading !== false">
        <b-spinner small></b-spinner>
      </div>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Debounce } from '@/model/Utils'

export default {
  name: 'accountPicker',
  props: {
    value: {
      required: true,
    },
    multi: {
      required: false,
    },
    selectProps: {
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    org:{},
    clearable: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    paginationSize: {
      type: Number,
      default: () => 10
    },
    sm:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  data: () => ({
    accounts: {},
    options: [],
    optionsPages: 0,
    optionsPage: 1,
    searchInput: '',
    loading: false,
    error: '',
    refreshOptionsDebounce: Debounce(() => {
    }, 500),
  }),
  watch:{
    value: {
      handler: function (val) {
        this.refreshAllAccounts()
      },
      immediate: true
    },
    org: {
      handler: function (val) {
        this.validateAccountsOrg()
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters('data', ['getOrganizationById', 'getBusinessUnitById']),
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  created() {
    this.refreshOptionsDebounce = Debounce(this.refreshOptions, 500)
    if((this.selected || []).length > 0){
      this.refreshAllAccounts()
    }
    this.refreshOptions(null);
  },
  methods: {
    ...mapActions('account', ['getAllAccounts']),
    refreshAllAccounts(){
      let selected = (this.selected || []).filter(id => this.accounts[id] == null);
      let $this = this
      if(selected.length <= 0){
        return;
      }
      this.loading = true
      console.log("refreshAllAccounts", selected)
      this.getAllAccounts({ filter: { ids: selected } })
          .then(result => {
            let accounts = result.data['accounts'];
            let clients = result.data['clients'].reduce((map, obj) => (map[obj.id] = obj, map), {});
            this.options = accounts.forEach(account => {
              $this.accounts[account.id] = $this.mapAccount(account, clients)
              return account.id
            })
            $this.validateAccountsOrg()
            $this.loading = false
            $this.$emit('input', $this.value)
          })
    },
    validateAccountsOrg(){
      console.log("validateAccountsOrg", this.org)
      if(this.org == null){
        return;
      }
      let $this = this
      let accountsInOrg = (this.selected || []).filter(id => {
       let isValid =  this.accounts[id] == null || this.getBusinessUnitById($this.accounts[id].businessUnitId).orgId === this.org;
       if(!isValid){
         console.warn("Account is not in org", {org:this.org,account:this.accounts[id],bu:this.getBusinessUnitById($this.accounts[id].businessUnitId)})
       }
       return isValid;
      });
      if(this.selected.length > accountsInOrg.length){
        this.selected = accountsInOrg;
      }
      this.options = [];
      this.optionsPages = 0;
    },
    refreshOptions(onCompleted) {
      let $this = this
      // console.log('refreshOptions', $this.searchInput)
      let request = {
        filter: { search: $this.searchInput },
        pagination:  { page: $this.optionsPage, size: $this.paginationSize }
      };
      if($this.org != null){
        request.filter.orgIds = [$this.org]
      }
      this.refreshAccounts(request, onCompleted)
    },
    refreshAccounts(request, onCompleted){
      let $this = this
      this.getAllAccounts(request)
          .then(result => {
            this.optionsPages = result.pagination.pages
            let accounts = result.data['accounts'];
            let clients = result.data['clients'].reduce((map, obj) => (map[obj.id] = obj, map), {});
            this.options = accounts.map(account => {
              $this.accounts[account.id] = $this.mapAccount(account, clients)
              return account.id
            })
          })
          .finally(() => {
            if (onCompleted) {
              onCompleted()
            }
            $this.loading = false
          })
    },
    mapAccount(account, clients){
      let client = clients[account.clientId];
      return { ...account,
        name: client.firstName + ' ' + client.lastName,
        businessUnitId: client.businessUnitId,
        buName: this.getBusinessUnitById(client.businessUnitId).name,
      }
    },
    getAccountMap(){
      return this.accounts || [];
    },
    getAccountById(id){
      return this.accounts[id] || null;
    },
    updatePage(page) {
      this.loading = true
      this.optionsPage += page;
      this.refreshOptionsDebounce(() => this.loading = false)
    },
    onSearch(search, loading) {
      loading(true)
      console.log('onSearch', search)
      this.optionsPage = 1;
      this.searchInput = search
      this.refreshOptionsDebounce(() => loading(false))
    }
  }
}
</script>

<style scoped>

</style>
